import React from "react";

function SocialAuthentication(){
    return (

        <>
        
        </>

    );
}

export default SocialAuthentication;